import { Command } from '@/app/tracking/api';

export interface AddSectionDurationCommandPayload {
  sectionId: string;
  durationSeconds: number;
}

export const AddSectionDurationCommandName = 'add-section-duration' as const;

export type AddSectionDurationCommand =
      Command<typeof AddSectionDurationCommandName, AddSectionDurationCommandPayload>;
